import classNames from 'classnames';
import React from 'react';
import { Link } from '../../../../../Link';
import { DesktopNavigatorTabListUnitFragment } from '../../../../../../generated/types';

import './DesktopSiteNavListColumnV2.scss';

interface Props {
  className?: string;
  content: DesktopNavigatorTabListUnitFragment;
}

export const DesktopSiteNavListColumnV2: React.FC<Props> = ({ className, content }) => (
  <div className={classNames('DesktopSiteNavListColumnV2', className)}>
    <h4 className="DesktopSiteNavListColumnV2__header">{content.header}</h4>

    {content.subcategories.map((subcategory, index) =>
      subcategory.href === '' ? (
        <h4
          key={subcategory.title + index}
          className="DesktopSiteNavListColumnV2__header-secondary"
        >
          {subcategory.title}
        </h4>
      ) : (
        <Link
          className="DesktopSiteNavListColumnV2__link"
          key={subcategory.href + index}
          to={subcategory.href}
        >
          {subcategory.title}
        </Link>
      )
    )}
  </div>
);
